function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import ListenersMixin from '../../mixins/listeners.js';
export default Vue.extend({
  name: 'QChatMessage',
  mixins: [ListenersMixin],
  props: {
    sent: Boolean,
    label: String,
    bgColor: String,
    textColor: String,
    name: String,
    avatar: String,
    text: Array,
    stamp: String,
    size: String,
    labelSanitize: Boolean,
    nameSanitize: Boolean,
    textSanitize: Boolean,
    stampSanitize: Boolean
  },
  computed: {
    textClass: function textClass() {
      return "q-message-text-content q-message-text-content--".concat(this.op) + (this.textColor !== void 0 ? " text-".concat(this.textColor) : '');
    },
    messageClass: function messageClass() {
      return "q-message-text q-message-text--".concat(this.op) + (this.bgColor !== void 0 ? " text-".concat(this.bgColor) : '');
    },
    containerClass: function containerClass() {
      return 'q-message-container row items-end no-wrap' + (this.sent === true ? ' reverse' : '');
    },
    sizeClass: function sizeClass() {
      if (this.size !== void 0) {
        return "col-".concat(this.size);
      }
    },
    op: function op() {
      return this.sent === true ? 'sent' : 'received';
    }
  },
  methods: {
    __wrapStamp: function __wrapStamp(h, node) {
      if (this.$scopedSlots.stamp !== void 0) {
        return [node, h('div', {
          staticClass: 'q-message-stamp'
        }, this.$scopedSlots.stamp())];
      }

      if (this.stamp) {
        var domPropStamp = this.stampSanitize === true ? 'textContent' : 'innerHTML';
        return [node, h('div', {
          staticClass: 'q-message-stamp',
          domProps: _defineProperty({}, domPropStamp, this.stamp)
        })];
      }

      return [node];
    },
    __getText: function __getText(h, contentList, withSlots) {
      var _this = this;

      var domPropText = this.textSanitize === true ? 'textContent' : 'innerHTML';

      if (withSlots === true && contentList.some(function (entry) {
        return entry.tag === void 0 && entry.text !== void 0;
      }) === true) {
        return [h('div', {
          "class": this.messageClass
        }, [h('div', {
          "class": this.textClass
        }, this.__wrapStamp(h, h('div', contentList)))])];
      }

      var content = withSlots !== true ? function (text) {
        return h('div', {
          domProps: _defineProperty({}, domPropText, text)
        });
      } : contentList.length > 1 ? function (text) {
        return text;
      } : function (text) {
        return h('div', [text]);
      };
      return contentList.map(function (msg, index) {
        return h('div', {
          key: index,
          "class": _this.messageClass
        }, [h('div', {
          "class": _this.textClass
        }, _this.__wrapStamp(h, content(msg)))]);
      });
    }
  },
  render: function render(h) {
    var container = [];

    if (this.$scopedSlots.avatar !== void 0) {
      container.push(this.$scopedSlots.avatar());
    } else if (this.avatar !== void 0) {
      container.push(h('img', {
        "class": "q-message-avatar q-message-avatar--".concat(this.op),
        attrs: {
          src: this.avatar,
          'aria-hidden': 'true'
        }
      }));
    }

    var msg = [];

    if (this.$scopedSlots.name !== void 0) {
      msg.push(h('div', {
        "class": "q-message-name q-message-name--".concat(this.op)
      }, this.$scopedSlots.name()));
    } else if (this.name !== void 0) {
      msg.push(h('div', {
        "class": "q-message-name q-message-name--".concat(this.op),
        domProps: _defineProperty({}, this.nameSanitize === true ? 'textContent' : 'innerHTML', this.name)
      }));
    }

    this.text !== void 0 && msg.push(this.__getText(h, this.text));
    this.$scopedSlots["default"] !== void 0 && msg.push(this.__getText(h, this.$scopedSlots["default"](), true));
    container.push(h('div', {
      "class": this.sizeClass
    }, msg));
    var child = [];

    if (this.$scopedSlots.label !== void 0) {
      child.push(h('div', {
        staticClass: 'q-message-label'
      }, this.$scopedSlots.label()));
    } else if (this.label !== void 0) {
      child.push(h('div', {
        staticClass: 'q-message-label',
        domProps: _defineProperty({}, this.labelSanitize === true ? 'textContent' : 'innerHTML', this.label)
      }));
    }

    child.push(h('div', {
      "class": this.containerClass
    }, container));
    return h('div', {
      "class": "q-message q-message-".concat(this.op),
      on: _objectSpread({}, this.qListeners)
    }, child);
  }
});